module.exports = __webpack_public_path__ + "static/media/5.d2c7efd1.png";